var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTensor = function SvgTensor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fillRule: "evenodd",
    height: 64,
    strokeLinejoin: "round",
    strokeMiterlimit: 1.414,
    width: 64,
    viewBox: "0 2 64 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.733 34.453 8.64-5.013 8.533 5.013-8.533 4.907-8.64-4.8zm-25.92-14.826 34.56-19.627 25.707 14.613-8.533 14.827-17.173-9.813-25.92 14.72z",
    fill: "#f6bd3a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.733 54.08v-9.813l8.533-4.907 8.64-4.907v9.813l-8.533 4.907v9.813l-8.64 5.014zm0-19.627-8.64-4.907-8.64 4.8v-9.813l25.92-14.72v19.627zm25.707-9.92v-4.907l8.64-5.013.107 9.813-8.64 5.013z",
    fill: "#eb8c23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.093 58.773v-29.226l8.533-4.8.107 9.707 8.64 4.8v9.92l-8.64-4.587v19.413zm-13.013-26.986-4.267-2.56v-9.6l8.64 4.907v9.813zm30.293-12.16v-9.814l17.067 9.813.107 9.813-17.173-9.813z",
    fill: "#e35a2b"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTensor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tensor.600ba7d1.svg";
export { ForwardRef as ReactComponent };